import { render } from "./MRegister.vue?vue&type=template&id=5e75692a&scoped=true"
import script from "./MRegister.vue?vue&type=script&lang=js"
export * from "./MRegister.vue?vue&type=script&lang=js"

import "./MRegister.vue?vue&type=style&index=0&id=5e75692a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e75692a"]])

export default __exports__